<template>
<modal
    name="delete-post"
    :width="0"
    @before-open="beforeOpen">
    <div class="modal modal__sphir_Online_Access_Agreement show">
        <section v-click-outside="hide">
            <a class="modal__close">
                <i
                    class="icon-close"
                    @click="hide" />
            </a>
            <div class="text__center margin-b__20">
                <b>{{ $t('DELETE_POST_MODAL.TITLE') }}</b>
            </div>
            <div class="flex flex__row flex__around">
                <button
                    class="btn__reset margin-r__10"
                    @click="hide">
                    {{ $t('BUTTON.NO') }}
                </button>
                <button
                    class="btn btn__m btn__round"
                    @click="handleDeletePost">
                    {{ $t('BUTTON.YES') }}
                </button>
            </div>
        </section>
    </div>
</modal>
</template>

<script>
    import {mapActions} from 'vuex'

    export default {
        name: 'DeletePostModal',
        data() {
            return {
                post: null
            }
        },
        methods: {
            ...mapActions('entities/posts', {
                deletePost: 'DELETE_POST_BY_ID'
            }),
            // @vuese
            // Method to hide DeletePost modal
            hide() {
                this.$modal.hide('delete-post')
            },
            handleDeletePost() {
                this.deletePost(this.post)
                this.hide()
            },
            // @vuese
            // Method that call before modal open and set to local data Post
            // @arg The argument is modal-open event with param Post [object]
            beforeOpen(event) {
                if (event && event.params && event.params.post) {
                    this.post = event.params.post.payload
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .modal__sphir_Online_Access_Agreement {
        section {
            width: 34rem;
        }
    }
</style>